import axios from 'axios';
import { flattenGizmoConfigs } from '../../gizmos/utils';
import { IGizmo, IIndex, IIndexColumn, IUserV2 } from '../../types';
import Dao from '../dao';

interface IParams {
  searchColumns: {
    values: string[];
    gizmoFid: string;
  }[];
  logicOperator?: 'and' | 'or';
  rootGizmoFid: string;
  gizmoConfig?: IGizmo;
  context: {
    apiUrl: string;
    dao: Dao;
    user?: IUserV2;
  };
}

function columnSearch({
  searchColumns,
  rootGizmoFid,
  logicOperator,
  gizmoConfig,
  context,
}: IParams): Promise<IIndex | undefined> {
  return new Promise<IIndex | undefined>(async resolve => {
    const { apiUrl, user, dao } = context;

    if (user?.credentials) {
      const credentials: any = user.credentials;
      let url = `${apiUrl}/main_api/v1/search/root_gizmo/data/${rootGizmoFid}`;

      // TODO: add pagination

      try {
        const columns: IIndexColumn[] = [];
        const forms = (
          await dao.getRootGizmoConfigs({
            fid: rootGizmoFid,
          })
        ).filter(f => f.fid === rootGizmoFid);

        let label = '';
        let showStatus = gizmoConfig?.ops?.index?.registers?.showStatus;

        for (const form of forms) {
          const flattenedGizmoConfigs = flattenGizmoConfigs({
            gizmos: form.gizmos!,
          });
          const columnGizmos = flattenedGizmoConfigs.filter(
            g => g.ops?.indexColumn?.isDisplayed
          );
          label = form.label;

          if (
            form.ops?.form?.registersIndex?.statusColumn?.display
              ?.isDisplayed !== undefined
          ) {
            showStatus =
              form.ops?.form?.registersIndex?.statusColumn?.display
                ?.isDisplayed;
          }

          if (columnGizmos) {
            for (const columnGizmo of columnGizmos) {
              columns.push({
                fid: columnGizmo.fid,
                label: columnGizmo.label,
                gizmo: columnGizmo,
              });
            }
          }
        }

        if (showStatus && forms.length === 1) {
          const statusColumn: IIndexColumn = {
            fid: 'cS',
            label: 'Status',
            type: 'status',
            status: forms[0].status,
          };

          columns.unshift(statusColumn);
        }

        const data: any = {
          searchColumns,
          gizmo: {},
        };
        if (logicOperator) {
          data.logicOperator = logicOperator;
        }

        const searchResponse = await axios.post(url, data, {
          headers: {
            ...credentials,
          },
        });

        if (searchResponse.status === 200) {
          const { filledForms } = searchResponse.data;

          if (filledForms && Array.isArray(filledForms)) {
            const index: IIndex = {
              fid: rootGizmoFid,
              pagination: {
                page: 1,
                pageSize: 10,
                total: 10,
              },
              columns,
              rows: filledForms,
            };

            if (label) {
              index.label = label;
            }

            if (
              gizmoConfig?.ops?.index?.operations &&
              Array.isArray(gizmoConfig.ops.index.operations)
            ) {
              const operationsColumn: IIndexColumn = {
                fid: 'c2',
                label: 'Ops',
                type: 'operations',
                operations: [],
              };

              for (const operation of gizmoConfig.ops.index.operations) {
                operationsColumn.operations?.push(operation);
              }

              index.columns.push(operationsColumn);
            }

            return resolve(index);
          }
        }
      } catch (e) {
        console.log('eeeeeeeeeeeeeeee: ', e);
      }
    }

    resolve(undefined);
  });
}

export default columnSearch;
